// extracted by mini-css-extract-plugin
export default {"btn_box":"SuccessPage_btn_box__g1D5a"};